export default __webpack_public_path__ + "static/media/search-not-found.01c4d884.svg";